export interface Service {
    Name: string
    ID: number
    IsEnabled
    IsLabService
    ShowInsurance
    ShowFileUpload
    EmailReportTo?
    Tests
    HtmlTemplate:string
    ImportantInformation:string
    InformedConsent: string
    Summary:string
    ReleaseOfInformation:string
    ROIConsentAuth:string
    CreatedBy?: string
    CreatedDate: Date
    LastUpdatedBy?: string
    LastUpdatedDate: Date
    CustomFieldData?
    AllowMultipleTests?
    ExportParseURL?
    PlatingDirection
    WellplateSettings
    ProductID?
    InternalIdentifierSettings
    AdditionalInformation
    EnablePayments
    PricingIDs
    IsDTC
    UpgradesToServiceID?: number | null
    IsUpgradable?: number | boolean | null
    // Form state stores a Select option ({label,value}); on save the
    // backend extracts the string value. Persisted column is VARCHAR(100)
    // / nullable. Typed loosely here to match the rest of this interface.
    ReportRenderer?
    // Form state stores a Select-multi value (array of {label,value}); on
    // save the backend extracts string[] and stringifies to JSON. Persisted
    // column is JSON / nullable. When set, the sample modal's renderer
    // picker is restricted to this list.
    AllowedRenderers?
}

export const BarcodeTypes = [{label:'1D', value:'1D'},{label:'2D', value:'2D'}];

export const getParent = (s: Service, all: Service[]): Service =>
    s && s.UpgradesToServiceID ? (all.find(x => x.ID === s.UpgradesToServiceID) || s) : s;

export const isUpgradeTarget = (s: Service, all: Service[]): boolean =>
    !!s && all.some(x => x.UpgradesToServiceID === s.ID);

export const isInTieredGroup = (s: Service, all: Service[]): boolean =>
    !!s && (!!s.UpgradesToServiceID || isUpgradeTarget(s, all));

export const isUpgradable = (s: Service): boolean => !!(s && s.IsUpgradable);

export interface InternalIdentifierSettings {
    ID: number
    StartingValue: string
    BarcodeType: string
}
